import { MoneyHelper } from '../../../core/helpers/money.helper';
import { CustomCurrencyPipe } from '../../../utilities/pipes/custom-currency.pipe';
import { CustomFormControlDefinition } from '../../../shared/utils/custom-form-control';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, TemplateRef } from '@angular/core';

@Component({
	selector: 'app-input-control',
	templateUrl: './input-control.component.html',
	styleUrls: ['./input-control.component.scss'],
})
export class InputControlComponent implements OnInit {
	@Input() controlDef: CustomFormControlDefinition;
	@Input() defaultSelectedItem: any;
	@Input() inputType: string;
	@Input() errorMessage: string;
	@Input() selectItems: SelectAdaptor[];
	@Input() today = new Date();
	@Input() disabledDate;
	@Input() iconPosition: 'left' | 'right'; // 'left or right'
	@Input() model: any;
	@Input() disableFutureDate: boolean;
	@Input() allowChanges = true;
	@Input() visibility = false;
	@Input() equalControlDef: CustomFormControlDefinition;
	@Input() showPlaceholder = true;
	@Input() suffixType: string;
	@Input() prefixType: string;
	@Input() disabled: boolean;
	@Input() selectOptionsTemplate: TemplateRef<any>;
	@Input() selectOptionsItems: any[];
	// kuwego field extension
	@Output() getBvnDetails = new EventEmitter();
	@Output() resetBvnDetails = new EventEmitter();
	@Input() isKuwegoLoanBvn: boolean;
	@Input() maxBvnLength: number;
	@Input() errorInBvn: any;
	showCorrectIcon = false;
	// **************************************** */
	@Output() valueChanged: EventEmitter<any> = new EventEmitter();
	@Output() actionClicked: EventEmitter<any> = new EventEmitter();
	@Output() inputFocused: EventEmitter<any> = new EventEmitter();
	@Output() inputBlurred: EventEmitter<any> = new EventEmitter();
	@Output() openChange: EventEmitter<any> = new EventEmitter();
	@Output() validForm = new EventEmitter();

	passwordVisible = false;
	@Input() selectedItem: any;
	@Input() isLoadingItems: boolean;
	controlTouched: boolean;

	constructor(public currencyPipe: CustomCurrencyPipe) {
	}
	ngOnChanges(changes: SimpleChange) {
		if (changes["errorInBvn"]?.currentValue) {
			this.showCorrectIcon = false;
		}

	}

	ngOnInit(): void {
		this.setDefaultSelectedItem();
	}

	setDefaultSelectedItem() {
		if (this.defaultSelectedItem) {
			this.selectedItem = this.defaultSelectedItem;
		}
	}

	getSelectValidationStatus() {

		if (this.controlDef?.required && this.controlTouched) {
			return this.selectedItem ? '' : 'error';
		}
		return '';
	}

	getSelectClass() {
		if (this.controlDef?.required && this.controlTouched) {
			return 'selected-item';
		}
		return this.selectedItem ? 'selected-item' : 'non-selected-item';
	}

	handleFocus() {
		this.setValidationStatus();
		this.inputFocused.emit(this.controlDef);
	}

	handleDate() {
		this.setValidationStatus();
		this.valueChanged.emit(this.controlDef);
	}

	// getFloatingBvnDetails($event){
	// 	this.getBvnDetails.emit($event)
	// }
	writeValue(evt: Event) {

		if (this.controlDef.isCurrencyAmount) {
			let value = this.controlDef.formGroupControl.value;
			value = this.normalizeCurrency(value);
			const rVal = this.currencyPipe.numberWithoutCommas(value);
			this.controlDef.formGroupControl.setValue(rVal);
		}
		if (
			this.controlDef.isAccountNumber ||
			this.controlDef.isBVN ||
			this.controlDef.isPhoneNumber ||
			this.controlDef.isOTP
		) {
			let value = this.controlDef.formGroupControl.value;
			value = this.normalizeNumber(value);
			this.controlDef.formGroupControl.setValue(value);
			// implementation here is for kuwego money loan

			if (value && this.isKuwegoLoanBvn) {

				// check for maximum value
				if (value.length === this.maxBvnLength) {

					// get to trigger the output call here.
					// show suffix icon here

					this.getBvnDetails.emit(value);
					if (!this.errorInBvn) {
						this.showCorrectIcon = true;
					} else {
						this.showCorrectIcon = false;
					}
				} else {

					this.showCorrectIcon = false;
					this.resetBvnDetails.emit();


				}


			}
		}
		if (this.controlDef.isAlphaNumeric) {
			let value = this.controlDef.formGroupControl.value;
			value = this.alphaNumbericValidation(value);
			this.controlDef.formGroupControl.setValue(value);
		}
		if (this.controlDef.isName) {
			let value = this.controlDef.formGroupControl.value;
			value = this.nameValidation(value);
			this.controlDef.formGroupControl.setValue(value);
		}
		if (this.controlDef.imposeUsernamePolicy) {
			let value = this.controlDef.formGroupControl.value;
			value = this.usernameValidation(value);
			this.controlDef.formGroupControl.setValue(value);
		}

		if (this.controlDef.type == 'select') {
			this.controlDef.formGroupControl.setValue(evt);
		}

		this.setValidationStatus();
		this.valueChanged.emit(this.controlDef);
	}

	handleOnBlur() {
		const value = this.controlDef.formGroupControl.value;
		this.setValidationStatus();
		this.inputBlurred.emit(value);
	}

	getDatePlaceHolder() {
		const isRequired = this.controlDef.required;
		if (isRequired) {
			return this.controlDef.formGroupControl.invalid ? this.controlDef.placeholder : ' ';
		}
		return ' ';
	}


	setValidationStatus() {
		const valid = this.controlDef.formGroupControl.valid;
		if (!valid) {
			this.controlDef.formGroupControl.markAsDirty();
			this.controlDef.formGroupControl.updateValueAndValidity({ onlySelf: true });
		}
		this.validForm.emit(valid);
	}

	hasMaximumValueError() {
		if (this.controlDef.formGroupControl.value) {
			const value = parseFloat(
				MoneyHelper.normalizeInputValue(this.controlDef.formGroupControl.value)
			);
			return (
				this.controlDef.allowChanges &&
				this.controlDef.formGroupControl.touched &&
				// this.controlDef.formGroupControl.hasError('max')
				value > this.controlDef.maxValue
			);
		}
	}

	setControlTouched() {
		if (!this.controlTouched) {
			this.controlTouched = true;
		}
		this.controlDef.formGroupControl.setValue(this.selectedItem);
		this.openChange.emit();
		// this.valueChanged.emit(this.controlDef);
	}

	openSelect() {
		const id = this.controlDef.id || 'custom-select'
		document.getElementById(id).click();
	}

	private normalizeCurrency = (val) => {
		if (typeof val === 'string') {
			val = val.split(',').join('');
			val = val.replace(/^0+/, '').replace(/[^0-9\.\d{1,2}]/g, ''); // This should remove leading zeros as well as non-numeric characters
			if (val.split('.').length > 2) {
				const float = parseFloat(val);
				val = float.toString();
			}
		}
		return val;
	}

	private normalizeNumber = (val) => {
		val = val ? val.toString().replace(/\D/g, '') : ''; // removes non digit character
		return val;
	}

	private nameValidation = (val) => {
		val = val ? val.toString().replace(/[^a-zA-Z-]+$/, '') : '';
		return val;
	}

	private usernameValidation = (val) => {
		val = val ? val.toString().replace(/[^a-zA-Z0-9_.@]/, '') : '';
		return val;
	}

	private alphaNumbericValidation = (val) => {
		val = val ? val.toString().replace(/[\W_]+/g, '') : '';
		return val;
	}
}

export interface SelectAdaptor {
	label: any;
	value: any;
}
